import { render, staticRenderFns } from "./120.vue?vue&type=template&id=ddda8c2a&scoped=true&"
var script = {}
import style0 from "./120.vue?vue&type=style&index=0&id=ddda8c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddda8c2a",
  null
  
)

export default component.exports